module.exports = __webpack_public_path__ + "static/media/recommender2.a8d33e55.png";